<template>
  <div id="pageDashboard">
    <v-toolbar class="top-content" flat>
      <v-toolbar-title class="title-box">
        <span class="title">Purchase Order Information</span>
        
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-flex xs3 sm4 class="mr-3">
        <v-autocomplete
          label="Province"
          v-model="provincesSelected"
          chips
          small-chips
          multiple
          :items="provinces"
          clearable
        >
          <template v-slot:selection="data">
            <v-chip
              v-if="provincesSelected.length < 2"
              v-bind="data.attrs"
              small
            >
              {{ data.item }}
            </v-chip>
            <div v-else-if="data.index === 0">
              {{ `${provincesSelected.length} items selected` }}
            </div>
          </template>
        </v-autocomplete>
      </v-flex>

      <v-flex xs3 sm4 class="mr-3">
        <v-text-field
            @click:clear="searchPo"
            append-icon="search"
            class="inp-search"
            clearable
            placeholder="Search"
            v-model="search"
            v-on:keydown="searchPo"
        ></v-text-field>

      </v-flex>

      <v-dialog
        content-class="dialog-po"
        max-width="700px"
        persistent
        v-model="dialog"
      >
        <!--  <v-btn class="mb-2" color="primary" dark slot="activator">Add</v-btn> -->
        <v-card>
          <v-card-title>{{ formTitle }}</v-card-title>
          <v-form
            data-vv-scope="formAddPO"
            lazy-validation
            ref="formPO"
            v-model="validForm"
          >
            <v-card-text class="pt-0">
              <v-container grid-list-md pb-0>
                <v-layout wrap>
                  <v-flex md6 xs12>
                    <v-text-field
                      :error-messages="errors.collect('formAddPO.po_number')"
                      data-vv-delay="500"
                      data-vv-name="po_number"
                      label="Purchase Order No"
                      v-if="editedIndex === -1"
                      v-model="editedItem.po_number"
                      v-validate="{
                        required: true,
                        max: 100,
                        regex: /^([A-Za-z0-9]+[A-Za-z0-9]*)$/,
                        unique: true,
                      }"
                    ></v-text-field>
                    <v-text-field
                      :error-messages="errors.collect('formAddPO.po_number')"
                      data-vv-delay="500"
                      data-vv-name="po_number"
                      label="Purchase Order No"
                      v-if="editedIndex >= 0"
                      v-model="editedItem.po_number"
                      v-validate="{
                        required: true,
                        max: 100,
                        regex: /^([A-Za-z0-9]+[A-Za-z0-9]*)$/,
                        unique: true,
                      }"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength300]"
                      label="Customer Name"
                      required
                      v-model="editedItem.customer_name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-select
                      :error-messages="errors.collect('formAddPO.gender')"
                      data-vv-name="gender"
                      label="Gender"
                      v-model="editedItem.gender"
                      :items="genderOptions"
                    ></v-select>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.birthDay"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      ref="birthdayPicker"
                      transition="scale-transition"
                      v-model="isBirthdayPickerOpen"
                    >
                      <v-text-field
                        label="Birthday"
                        prepend-icon="event"
                        readonly
                        clearable
                        slot="activator"
                        v-model="editedItem.birthDay"
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="editedItem.birthDay"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="isBirthdayPickerOpen = false"
                          color="primary"
                          flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="
                            $refs.birthdayPicker.save(editedItem.birthDay)
                          "
                          color="primary"
                          flat
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.validPhoneNumber]"
                      data-vv-name="phone_number"
                      label="Customer Phone Number"
                      v-model="editedItem.phone_number"
                      v-validate="'required'"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-combobox
                      :rules="[rules.arrRequired, rules.emails]"
                      v-if="editedIndex === -1"
                      multiple
                      append-icon=""
                      label="Customer Email"
                      v-model="editedItem.email"
                      small-chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          :color="getColor(data.item)"
                          @input="removeChip(data.item)"
                        >
                          <strong>{{ data.item }}</strong
                          >&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                    <v-combobox
                      :rules="[rules.arrRequired, rules.emails]"
                      v-if="editedIndex >= 0"
                      multiple
                      append-icon=""
                      label="Customer Email"
                      v-model="editedItem.email"
                      small-chips
                      clearable-chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          :color="getColor(data.item)"
                          @input="removeChip(data.item)"
                        >
                          <strong>{{ data.item }}</strong
                          >&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength300]"
                      label="Job Site Address"
                      required
                      v-model="editedItem.execution_address"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-autocomplete
                      label="Province"
                      v-model="editedItem.province"
                      clearable
                      :items="provinces"
                      :rules="[rules.required]"
                      v-validate="'required'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-autocomplete
                      :rules="[rules.required]"
                      v-validate="'required'"
                      :items="modelList"
                      label="Model"
                      required
                      small-chips
                      v-model="editedItem.model"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[byPassOldPO(this.editedIndex)]"
                      label="Contract No"
                      required
                      v-model="editedItem.contract_no"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      label="Appendix"
                      required
                      v-model="editedItem.appendix"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      label="Company name"
                      required
                      v-model="editedItem.company_name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-autocomplete
                      :items="yearList"
                      label="Manufacture year"
                      small-chips
                      v-model="editedItem.manufacture_year"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.signing_date"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      ref="signingDate"
                      transition="scale-transition"
                      v-model="signingDate"
                    >
                      <v-text-field
                        :rules="[byPassOldPO(this.editedIndex)]"
                        v-validate="'required'"
                        label="Contract Signing Date"
                        prepend-icon="event"
                        required
                        readonly
                        slot="activator"
                        v-model="editedItem.signing_date"
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="objDate.signing_date"
                      >
                        <v-spacer></v-spacer>
                        <v-btn @click="signingDate = false" color="primary" flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="$refs.signingDate.save(objDate.signing_date)"
                          color="primary"
                          flat
                          >OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.warranty_expired_date"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      ref="warrantyDate"
                      transition="scale-transition"
                      v-model="warrantyDate"
                    >
                      <v-text-field
                        label="Warranty Expired Date"
                        prepend-icon="event"
                        readonly
                        slot="activator"
                        v-model="editedItem.warranty_expired_date"
                        clearable
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="objDate.warranty_expired_date"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="warrantyDate = false"
                          color="primary"
                          flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="
                            $refs.warrantyDate.save(
                              objDate.warranty_expired_date
                            )
                          "
                          color="primary"
                          flat
                          >OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.maintain_expired_date"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      ref="mainDate"
                      transition="scale-transition"
                      v-model="mainDate"
                    >
                      <v-text-field
                        label="Maintain Expired Date"
                        prepend-icon="event"
                        readonly
                        clearable
                        slot="activator"
                        v-model="editedItem.maintain_expired_date"
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="objDate.maintain_expired_date"
                      >
                        <v-spacer></v-spacer>
                        <v-btn @click="mainDate = false" color="primary" flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="
                            $refs.mainDate.save(objDate.maintain_expired_date)
                          "
                          color="primary"
                          flat
                          >OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.next_maintain_date"
                      full-width
                      lazy
                      min-width="290px"
                      offset-y
                      ref="nextDate"
                      transition="scale-transition"
                      v-model="nextDate"
                    >
                      <v-text-field
                        label="Next Maintain Date"
                        prepend-icon="event"
                        readonly
                        slot="activator"
                        v-model="editedItem.next_maintain_date"
                      ></v-text-field>
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="objDate.next_maintain_date"
                      >
                        <v-spacer></v-spacer>
                        <v-btn @click="nextDate = false" color="primary" flat
                          >Cancel</v-btn
                        >
                        <v-btn
                          @click="
                            $refs.nextDate.save(objDate.next_maintain_date)
                          "
                          color="primary"
                          flat
                          >OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-combobox
                      :rules="[
                        rules.arrRequired,
                        rules.emails,
                        rules.maxLength100,
                      ]"
                      v-if="editedIndex === -1"
                      multiple
                      append-icon=""
                      label="Seller Email Address"
                      v-model="editedItem.seller_email_address"
                      small-chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          :color="getColor(data.item)"
                          @input="removeSeller(data.item)"
                        >
                          <strong>{{ data.item }}</strong
                          >&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                    <v-combobox
                      :rules="[
                        rules.arrRequired,
                        rules.emails,
                        rules.maxLength100,
                      ]"
                      v-if="editedIndex >= 0"
                      multiple
                      append-icon=""
                      label="Seller Email Address"
                      v-model="editedItem.seller_email_address"
                      small-chips
                      clearable-chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          :color="getColor(data.item)"
                          @input="removeSeller(data.item)"
                        >
                          <strong>{{ data.item }}</strong
                          >&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="Pit"
                      required
                      v-model="editedItem.pit"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="Required cut out size"
                      required
                      v-model="editedItem.cut_out_size"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-autocomplete
                      :rules="[rules.required]"
                      v-validate="'required'"
                      :items="localtion"
                      label="Installation location"
                      required
                      small-chips
                      v-model="editedItem.localtion"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="TH (as specified sales contract)"
                      required
                      v-model="editedItem.journey"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="Required open width"
                      required
                      v-model="editedItem.required_open_width"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="Required open height"
                      required
                      v-model="editedItem.required_open_height"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-autocomplete
                      :items="floor"
                      label="No. of stops"
                      required
                      small-chips
                      v-model="editedItem.floor"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-autocomplete
                      :rules="[rules.required]"
                      v-validate="'required'"
                      :items="electricity"
                      label="Electricity"
                      required
                      small-chips
                      v-model="editedItem.electricity"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="OH (as specified by sales contract)"
                      required
                      v-model="editedItem.overhead"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      :rules="[rules.required, rules.maxLength50]"
                      label="Total lift weight"
                      required
                      v-model="editedItem.total_lift_weight"
                    ></v-text-field>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-autocomplete
                      :rules="[rules.required]"
                      v-validate="'required'"
                      :items="brand"
                      label="Select Brand"
                      required
                      small-chips
                      v-model="editedItem.brand"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="editedItem.order_date"
                    full-width
                    lazy
                    min-width="290px"
                    offset-y
                    ref="orderDate"
                    transition="scale-transition"
                    v-model="isOrderDateOpen"
                  >
                    <v-text-field
                      label="Order date"
                      prepend-icon="event"
                      readonly
                      clearable
                      slot="activator"
                      v-model="editedItem.order_date"
                    ></v-text-field>
                    <v-date-picker
                      no-title
                      scrollable
                      v-model="editedItem.order_date"
                      :max="today"
                      :allowed-dates="allowedPastDates"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="isOrderDateOpen = false"
                        color="primary"
                        flat
                        >Cancel</v-btn
                      >
                      <v-btn
                        @click="
                          $refs.orderDate.save(
                            editedItem.order_date
                          )
                        "
                        color="primary"
                        flat
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                  </v-flex>
                  <!-- bảo dưỡng miễn phí -->
                  <!-- <v-layout wrap>
                                    <v-flex md12 xs12>
                                        <v-checkbox :rules="validateCheckbox" required v-model="editedItem.free_maintenance" label="Free maintenance"></v-checkbox>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.free_maintenance && editedItem.is_new_data">
                                        <v-text-field :error-messages="
                            errors.collect('formAddPO.periodic_maintenance')
                          " label="Number of periodic maintenance" data-vv-name="periodic_maintenance" required v-validate="{
                            required: true,
                            regex: /^([+]{0,1}[0-9]+)$/s,
                            max_value: 100000,
                            min_value: editedItem.form_free_maintenance.maintain_num,
                          }" v-model="editedItem.form_free_maintenance.periodic_maintenance"></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.free_maintenance && !editedItem.is_new_data">
                                        <v-text-field :error-messages="
                            errors.collect('formAddPO.periodic_maintenance')
                          " label="Number of periodic maintenance" data-vv-name="periodic_maintenance" required v-validate="{
                            required: true,
                            regex: /^([+]{0,1}[0-9]+)$/s,
                            max_value: 100000,
                            min_value: editedItem.maintain_num,
                          }" v-model="editedItem.periodic_maintenance"></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.free_maintenance && editedItem.is_new_data">
                                        <v-text-field label="Maintain number" required disabled v-model="editedItem.form_free_maintenance.maintain_num"></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.free_maintenance && !editedItem.is_new_data">
                                        <v-text-field label="Maintain number" required disabled v-model="editedItem.maintain_num"></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.free_maintenance && editedItem.is_new_data">
                                        <v-text-field :error-messages="
                            errors.collect(
                              'formAddPO.remaining_periodic_maintenance'
                            )
                          " required label="Number of remaining periodic maintenance" v-model="editedItem.form_free_maintenance.remaining_periodic_maintenance" data-vv-name="remaining_periodic_maintenance" disabled></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.free_maintenance && !editedItem.is_new_data">
                                        <v-text-field :error-messages="
                            errors.collect(
                              'formAddPO.remaining_periodic_maintenance'
                            )
                          " required label="Number of remaining periodic maintenance" v-model="editedItem.remaining_periodic_maintenance" data-vv-name="remaining_periodic_maintenance" disabled></v-text-field>
                                    </v-flex>
                                </v-layout> -->
                  <!-- end bảo dưỡng miễn phí -->
                  <!-- Bảo dưỡng tính phí -->
                  <!-- <v-layout wrap>
                                    <v-flex md12 xs12>
                                        <v-checkbox :rules="validateCheckbox" required  v-model="editedItem.chargeable_maintenance" label="Charge maintenance"></v-checkbox>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.chargeable_maintenance">
                                        <v-text-field :error-messages="
                            errors.collect('formAddPO.charge_maintenance')
                          " label="Number of charged maintenance" data-vv-name="charge_maintenance" required v-validate="{
                            required: true,
                            regex: /^([+]{0,1}[0-9]+)$/s,
                            max_value: 100000,
                            min_value: editedItem.form_chargeable_maintenance.maintain_num,
                          }" v-model="editedItem.form_chargeable_maintenance.periodic_maintenance"></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.chargeable_maintenance">
                                        <v-text-field label="Maintain number" required disabled v-model="editedItem.form_chargeable_maintenance.maintain_num"></v-text-field>
                                    </v-flex>
                                    <v-flex md6 xs12 v-if="editedItem.chargeable_maintenance">
                                        <v-text-field :error-messages="
                            errors.collect(
                              'formAddPO.remaining_charge_maintenance'
                            )
                          " required label="Number of remaining charged maintenance" v-model="editedItem.form_chargeable_maintenance.remaining_periodic_maintenance" data-vv-name="remaining_charge_maintenance" disabled></v-text-field>
                                    </v-flex>
                                </v-layout> -->
                  <!-- end bảo dưỡng tính phí -->
                  <!-- form hợp đôngg -->
                  <!-- <v-layout wrap v-if="editedItem.chargeable_maintenance">
                                    <v-flex md12 xs12>
                                        <v-btn @click="addContract" color="primary">
                                            Add Contract
                                        </v-btn>
                                    </v-flex>
                                    <v-layout wrap v-for="(row, index) in editedItem.form_chargeable_maintenance.form_contact" :key="index">
                                        <v-flex md12 xs12>
                                            <v-checkbox v-model="row.check_point" hide-details label="Show info on cibes backoffice"></v-checkbox>
                                        </v-flex>
                                        <v-flex md6 xs12>
                                            <v-text-field label="Maintenance contract number" required v-model="row.maintenance_contract_number"></v-text-field>
                                        </v-flex>
                                        <v-flex md6 xs12>
                                            <v-text-field label="Maintenance package" required v-model="row.maintenance_package"></v-text-field>
                                        </v-flex>
                                        <v-flex md6 xs12>
                                            <v-menu :close-on-content-click="false" :nudge-right="40" :return-value.sync="row.contract_signing_date" full-width lazy min-width="290px" offset-y :ref="'dialog' + index" transition="scale-transition" v-model="contractDate[index]">
                                                <v-text-field label="Contract signing date" prepend-icon="event" readonly slot="activator" v-model="row.contract_signing_date"></v-text-field>
                                                <v-date-picker no-title scrollable v-model="row.contract_signing_date">
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="contractDate[index] = false" color="primary" flat>Cancel</v-btn>
                                                    <v-btn @click="$refs['dialog' + index][0].save(
                              row.contract_signing_date
                            )" color="primary" flat>OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex md6 xs12>
                                            <v-menu :close-on-content-click="false" :nudge-right="40" :return-value.sync="row.effective_time" full-width lazy min-width="290px" offset-y :ref="'effect' + index" transition="scale-transition" v-model="effectiveTime[index]">
                                                <v-text-field label="Expiration time" prepend-icon="event" readonly slot="activator" v-model="row.effective_time"></v-text-field>
                                                <v-date-picker no-title scrollable v-model="row.effective_time">
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="effectiveTime[index] = false" color="primary" flat>Cancel</v-btn>
                                                    <v-btn @click="$refs['effect' + index][0].save(
                              row.effective_time
                            )" color="primary" flat>OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-layout> -->
                  <!-- end form hợp đồng -->
                  <v-flex md12 xs12>
                    <v-textarea
                      label="Internal note"
                      v-model="editedItem.note"
                    ></v-textarea>
                  </v-flex>
                  <v-flex md12 xs12>
                    <v-autocomplete
                      :items="userList"
                      :loading="loadingSelectUser"
                      label="Select user assign"
                      multiple
                      small-chips
                      v-model="editedItem.assign_users"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex md12 xs12>
                    <v-checkbox
                      v-model="editedItem.inStock"
                      hide-details
                      label="In stock"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex>
                    <div style="display: flex">
                      <div class="dropbox">
                        <v-btn color="blue-grey" class="white--text">
                          Select File Upload
                          <v-icon right dark>cloud_upload</v-icon>
                        </v-btn>

                        <input
                          id="files"
                          ref="files"
                          type="file"
                          multiple
                          :name="uploadFieldName"
                          v-on:change="handleFilesUpload()"
                          accept=".xlsx,.xls,image/*,.doc,.docx,.pdf"
                          class="input-file"
                        />
                      </div>
                      <div v-if="files">
                        <h5 style="margin-top: 20px">
                          Uploaded {{ files.length }} file(s).
                        </h5>

                        <ul class="list-unstyled">
                          <div class="large-12 medium-12 small-12 cell">
                            <div
                              v-for="(file, key) in files"
                              :key="key"
                              class="file-listing"
                            >
                              <v-icon style="margin-bottom: -2px"
                                >attach_file</v-icon
                              >
                              <span class="name-file">{{ file.name }}</span>
                              <v-icon
                                style="margin-bottom: -2px"
                                right
                                color="red"
                                v-on:click="removeFile(key)"
                                >remove_circle</v-icon
                              >
                            </div>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogConfirm = true">Cancel</v-btn>
              <v-btn @click="save" color="primary">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog max-width="450px" persistent v-model="dialogStatus">
        <v-card>
          <v-card-title>
            <span class="headline">Alert</span>
          </v-card-title>
          <v-card-text>{{ res_msg }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogStatus = false" style="width: 85px"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog max-width="450px" persistent v-model="dialogConfirm">
        <v-card>
          <v-card-title>
            <span class="headline">Alert</span>
          </v-card-title>
          <v-card-text>{{ title2 }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
            <v-btn @click="close" color="primary" style="width: 85px"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog max-width="100px" persistent v-model="dialogSaving">
        <v-card>
          <v-card-text>
            <v-layout d-flex column align-center>
              <v-progress-circular
                indeterminate
                color="primary"
                size="36"
                class="mb-3"
              ></v-progress-circular>
              <span>Saving...</span>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <purchase-order-maintenance
        v-model="dialogMaintenance"
        :po-id="id"
        :user-list="userList"
        :loading-select-user="loadingSelectUser"
        :refetch-data="getData"
      ></purchase-order-maintenance>
      <purchase-order-repair
        v-model="dialogRepair"
        :po-id="id"
        :user-list="userList"
        :loading-select-user="loadingSelectUser"
      ></purchase-order-repair>

      <purchase-order-delivery 
        v-model="dialogDelivery"
        :po-id="id"
        :refetch-data="getData"
      >
      </purchase-order-delivery>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="moduleData"
      :loading="loading"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="totalItems"
      class="elevation-1 list-po"
      item-key="name"
    >
      <template v-slot:headers="props">
        <th
          :class="[
            'column',
            !(typeof header.sortable === 'boolean' && !header.sortable)
              ? 'sortable'
              : '',
            header.align ? header.align : 'text-xs-left',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '',
          ]"
          :key="header.text"
          @click="changeSort(header)"
          v-for="header in props.headers"
        >
          {{ header.text }}
          <v-icon
            small
            v-if="!(typeof header.sortable === 'boolean' && !header.sortable)"
            >arrow_upward</v-icon
          >
        </th>
      </template>
      <template slot="items" slot-scope="props">
        <tr
          :active="props.selected"
          @click="props.selected = !props.selected"
          style="color: rgba(0, 0, 0, 0.87) !important"
        >
          <td class="text-xs-left">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }">{{
              props.item.po_number
            }}</router-link>
          </td>
          <td class="text-xs-left">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }">{{
              props.item.customer_name
            }}</router-link>
          </td>
          <td class="text-xs-center">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }"
              >{{
                props.item.warranty_expired_date | morph-date("DD/MM/YYYY")
              }}
            </router-link>
          </td>
          <td class="text-xs-center">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }"
              >{{
                props.item.maintain_expired_date | morph-date("DD/MM/YYYY")
              }}
            </router-link>
          </td>
          <td class="text-xs-center">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }"
              >{{
                props.item.latest_maintain_date | morph-date("DD/MM/YYYY")
              }}
            </router-link>
          </td>
          <td class="text-xs-center">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }"
              >{{
                props.item.next_maintain_date | morph-date("DD/MM/YYYY")
              }}
            </router-link>
          </td>
          <td class="text-xs-center">
            <router-link :to="{ name: 'Job', params: { id: props.item.id } }"
              >{{ props.item.signing_date | morph-date("DD/MM/YYYY") }}
            </router-link>
          </td>
          <td class="text-xs-center nowrap">
            <template
              v-if="
                currentUser &&
                (currentUser.user_type === isAdmin ||
                  currentUser.user_type === isSuperAdmin)
              "
            >
              <v-icon @click="editItem(props.item)" class="mr-2" small
                >edit</v-icon
              >
              <v-icon @click="editMaintenance(props.item)" class="mr-2" small
                >build</v-icon
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                class="v-icon v-icon--link theme--light"
                @click="editRepair(props.item)"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M6.75 10h4.5q.3 0 .525-.225T12 9.25t-.225-.525t-.525-.225h-4.5q-.3 0-.525.225T6 9.25t.225.525t.525.225m0-2.5h4.5q.3 0 .525-.225T12 6.75t-.225-.525T11.25 6h-4.5q-.3 0-.525.225T6 6.75t.225.525t.525.225M17 11V5h1q.825 0 1.413.588T20 7h2q.425 0 .713.288T23 8t-.288.713T22 9h-2q0 .825-.587 1.413T18 11zm-5 4.5H6V13q-1.65 0-2.825-1.175T2 9V7q0-1.65 1.175-2.825T6 3h8q.825 0 1.413.588T16 5v6q0 .825-.587 1.413T14 13h-2zM5.5 21q-.625 0-1.062-.437T4 19.5V18q0-.625.438-1.062T5.5 16.5h7q.625 0 1.063.438T14 18v1.5q0 .625-.437 1.063T12.5 21z"
                />
              </svg>

              <v-icon @click="openDeliveryModal(props.item)" class="ml-2" small>
                local_shipping
              </v-icon>
            </template>
          </td>
        </tr>
      </template>

      <template v-slot:actions-prepend>
        <div class="actions-list">
          <v-btn
            @click="eventAddPO($event)"
            color="primary"
            v-if="
              currentUser &&
              (currentUser.user_type === isAdmin ||
                currentUser.user_type === isSuperAdmin)
            "
          >
            Add
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PurchaseOrderService from "../services/purchase.order.service.js";
import UserService from "../services/user.service.js";
import ModelService from "../services/model.service.js";
import { Validator } from "vee-validate";
import { format, parse, isBefore, isEqual } from "date-fns";
import { debounce, isEmpty } from "lodash";
import { setTimeout } from "timers";
import imageCompression from "browser-image-compression";
import PurchaseOrderMaintenance from "./PurchaseOrderMaintenance.vue";
import PurchaseOrderRepair from "./PurchaseOrderRepair.vue";
import PurchaseOrderDelivery from "./PurchaseOrderDelivery.vue";
import provinceList from "../config/provinces.js";
import genderList from "../config/genders.js";

export default {
  inject: ["$validator"],
  metaInfo() {
    return {
      title: "Manage Purchase Order",
    };
  },
  components: {
    PurchaseOrderMaintenance,
    PurchaseOrderRepair,
    PurchaseOrderDelivery
  },
  data: () => ({
    // Render ra các properties sử dụng trong template.
    today: format(new Date(), 'yyyy-MM-dd'),
    files: [],
    filesUrl: [],
    uploadFieldName: "uploadFiles",
    isAdmin: 4,
    isSuperAdmin: 3,
    validForm: true,
    dialogStatus: false,
    res_msg: "",
    pagination: {
      rowsPerPage: 10,
      sortBy: "createdAt",
      descending: true,
      page: 1,
    },
    totalItems: 0,
    rowsPerPageItems: [10, 20, 50],
    breadcrumbs: [
      {
        text: "Purchase",
      },
    ],
    dialog: false,
    dialogMaintenance: false,
    dialogRepair: false,
    dialogDelivery: false,
    /* contractDate: [],
        effectiveTime: [], */
    warrantyDate: false,
    mainDate: false,
    nextDate: false,
    signingDate: false,
    searchUser: null,
    search: null,
    editedIndex: -1,
    purchaseOrderService: new PurchaseOrderService(),
    userService: new UserService(),
    modelService: new ModelService(),
    isOrderDateOpen: false,
    editedItem: {
      po_number: "",
      model: "",
      seller_email_address: [],
      execution_address: "",
      province: "",
      phone_number: "",
      customer_name: "",
      first_name: "",
      last_name: "",
      gender: genderList[2].value,
      birthDay: "",
      email: [],
      password: "",
      user_type: "",
      pit: "",
      cut_out_size: "",
      localtion: "",
      journey: "",
      required_open_height: "",
      required_open_width: "",
      contract_no: "",
      appendix: "",
      company_name: "",
      floor: 0,
      electricity: "",
      overhead: "",
      total_lift_weight: "",
      active: true,
      brand: "",
      note: "",
      inStock: false,
      files: [],
      order_date: ""
      /* free_maintenance: true,
            form_free_maintenance: {
                maintain_num: 0,
                periodic_maintenance: 0,
                remaining_periodic_maintenance: 0
            },
            chargeable_maintenance: false || null,
            form_chargeable_maintenance: {
                maintain_num: 0,
                periodic_maintenance: 0,
                remaining_periodic_maintenance: 0,
                form_contact: [],
            },
            is_new_data: true */
    },
    defaultItem: {
      po_number: "",
      model: "",
      seller_email_address: [],
      execution_address: "",
      province: "",
      phone_number: "",
      customer_name: "",
      first_name: "",
      last_name: "",
      gender: genderList[2].value,
      birthDay: "",
      email: [],
      password: "",
      user_type: "",
      pit: "",
      cut_out_size: "",
      localtion: "",
      journey: "",
      required_open_height: "",
      required_open_width: "",
      contract_no: "",
      appendix: "",
      company_name: "",
      floor: 0,
      electricity: "",
      overhead: "",
      total_lift_weight: "",
      active: true,
      brand: "",
      note: "",
      inStock: false,
      files: [],
      order_date: ""
    },
    userList: [],
    note: "",
    modelList: [],
    yearList: [],
    genderOptions: genderList,
    isBirthdayPickerOpen: false,
    floor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    localtion: [
      "Giữa thang bộ",
      "Cạnh thang bộ",
      "Đối diện thang bộ",
      "Góc nhà",
      "Trong giếng",
      "Toàn bộ ngoài trời",
      "Bán ngoài trời",
      "Giữa nhà",
    ],
    electricity: ["1 pha, 230 V", "3 pha, 380V"],
    brand: ["Cibes", "Kalea"],
    loadingSelectUser: false,
    sortBy: "",
    actionSearch: false,
    loading: false,
    id: "",
    rules: {
      required: (v) => (v && v.trim().length > 0) || "It is required field",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      arrRequired: (values) => values.length > 0 || "It is required field",
      emails: (values) => {
        const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        for (let i = 0; i < values.length; i++) {
          if (!pattern.test(values[i])) {
            return "Invalid e-mail.";
          }
        }
        return true;
      },
      maxLength100: (v) => (v && v.length <= 100) || "Max 100 characters",
      maxLength50: (v) => (v && v.length <= 50) || "Max 50 characters",
      maxValue100: (v) => v <= 100 || "Max 100 floors",
      maxLength300: (v) => (v && v.length <= 300) || "Max 300 characters",
      minValue: (v) => v >= 0 || "Min 0 floor",
      noOfStops: {
        valid: (v) =>
          (!isNaN(parseFloat(v)) && isFinite(v)) ||
          (v === "" ? "It is required  field" : "Invalid Number"),
        required: (v) => !!v || "It is required  field",
      },
      validPhoneNumber: (value) => {
        const phoneRegex = /^0[1-9]\d{8}$/;
        return (
          phoneRegex.test(value) || "The phone number field must be 10 digits."
        );
      },
    },
    userTypes: [
      {
        text: "Technical Member",
        value: 1,
      },
      {
        text: "Technical Leader",
        value: 2,
      },
      {
        text: "Admin",
        value: 3,
      },
    ],
    selected: [],
    headers: [
      {
        text: "PO Number",
        value: "po_number",
      },
      {
        text: "Customer Name",
        value: "customer_name",
      },
      {
        text: "Warranty Expired Date",
        value: "warranty_expired_date",
        align: "text-xs-center",
      },
      {
        text: "Maintain Expired Date",
        value: "maintain_expired_date",
        align: "text-xs-center",
      },
      {
        text: "Latest Maintain Date",
        value: "latest_maintain_date",
        align: "text-xs-center",
      },
      {
        text: "Next Maintain Date",
        value: "next_maintain_date",
        align: "text-xs-center",
      },
      {
        text: "Contract Signing Date",
        value: "signing_date",
        align: "text-xs-center",
      },
      {
        text: "Action",
        sortable: false,
        align: "text-xs-center",
      },
    ],
    moduleData: [],
    isDisabled: true,
    dictionary: {
      custom: {
        po_number: {
          required: () => "It is required field",
          max: () => "Max 100 characters",
          regex: () => "The PO Number field format is invalid.",
        },
        // periodic_maintenance: {
        //   required: () => "It is required field",
        //   max: () => "Maximum characters",
        //   // regex: () => "The PO Number field format is invalid.",
        //   min_value: () =>
        //     "Number of periodic maintenance must be greater than maintain number.",
        // },
        // charge_maintenance: {
        //   required: () => "It is required field",
        //   max: () => "Maximum characters",
        //   regex: () => "The PO Number field format is invalid.",
        //   min_value: () =>
        //     "Number of charged maintenance must be greater than maintain number.",
        // },
        // remaining_periodic_maintenance: {
        //   required: () => "It is required field",
        //   max: () => "Maximum characters",
        //   regex: () => "The PO Number field format is invalid.",
        // },
        // remaining_charge_maintenance: {
        //   required: () => "It is required field",
        //   max: () => "Maximum characters",
        //   regex: () => "The PO Number field format is invalid.",
        // },
        phone_number: {
          regex: () => "The phone number field format is invalid.",
        },
        valid_floor: {
          required: () => "It is required field",
          max_value: () => "Max 100 floors",
          regex: () => "Invalid No. of stops",
        },
      },
    },
    clickAdd: true,
    dialogConfirm: false,
    objDate: {
      warranty_expired_date: format(new Date(), "YYYY-MM-DD"),
      maintain_expired_date: format(new Date(), "YYYY-MM-DD"),
      next_maintain_date: format(new Date(), "YYYY-MM-DD"),
      signing_date: format(new Date(), "YYYY-MM-DD"),
    },
    curPOID: "",
    LIMIT_SIZE: 20,
    listSizeFile: [],
    LIMIT_SINGLE_IMAGE_SIZE: 2,
    LIMIT_SINGLE_IMAGE_LONG_EDGE: 2048,
    dialogSaving: false,
    provincesSelected: [],
  }),
  created() {
    this.searchDataUser();
    this.getListModel();
    this.getListYear();
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    searchUser(query) {
      this.querySearch({
        search: query,
        limit: 1000,
      });
    },

    provincesSelected() {
      this.getData();
    },

    /* "editedItem.form_free_maintenance.periodic_maintenance"(newValue) {
            if (newValue && newValue > 0) {
                this.editedItem.form_free_maintenance.remaining_periodic_maintenance = +newValue - this.editedItem.form_free_maintenance.maintain_num;
            } else {
                this.editedItem.form_free_maintenance.remaining_periodic_maintenance = null;
            }
        },
        "editedItem.form_chargeable_maintenance && editedItem.form_chargeable_maintenance.periodic_maintenance"(newValue) {
            if (newValue && newValue > 0) {
                this.editedItem.form_chargeable_maintenance.remaining_periodic_maintenance = +newValue - this.editedItem.form_chargeable_maintenance.maintain_num;
            } else {
                this.editedItem.form_chargeable_maintenance.remaining_periodic_maintenance = null;
            }
        }, */
  },
  mounted() {
    const isUnique = (value) => {
      if (value === this.curPOID) {
        return {
          valid: true,
          data: {
            message: "",
          },
        };
      }
      return this.purchaseOrderService.checkPO(value).then((res) => {
        return {
          valid: !res.is_exists,
          data: {
            message: "PO has already exists on the system",
          },
        };
      });
    };
    this.$validator.localize("en", this.dictionary);
    Validator.extend("unique", {
      validate: isUnique,
      getMessage: (field, params, data) => data.message,
    });
  },
  computed: {
    // là các pure-func đc cache lại và chỉ re-render khi mà có gtri thay đổi, k có params.
    formTitle() {
      return this.editedIndex === -1
        ? "Add Purchase Order"
        : "Edit Purchase Order";
    },
    title2() {
      return this.editedIndex === -1
        ? "Are you sure to cancel the new PO creation?"
        : "Are you sure to cancel the changes?";
    },
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    },
    /* validateCheckbox() {
            return [this.editedItem.free_maintenance || this.editedItem.chargeable_maintenance || 'It is required field']
        }, */
    provinces() {
      return provinceList;
    },
  },
  methods: {
    // tạo ra các function sủ dụng ở chính nó và trong template. Có params truyền vào.
    handleFilesUpload() {
      const fileList = this.$refs.files.files || [];
      // console.log(fileList);
      const sumSizeFileUpload = this.sumSizeFiles(fileList);
      const sumSizeCurrent =
        this.listSizeFile.length > 0 ? this.sumSizeFiles(this.listSizeFile) : 0; // delete

      if (
        sumSizeFileUpload + sumSizeCurrent >
        this.LIMIT_SIZE * Math.pow(1024, 2)
      ) {
        this.dialogStatus = true;
        this.res_msg = `Maximum file size is ${this.LIMIT_SIZE}MB`;
        return;
      }

      const reg =
        /(image\/*)|(application\/pdf)|(application\/msword)|(application\/vnd\.openxmlformats.(officedocument.spreadsheetml.sheet|officedocument.wordprocessingml.document))|(application\/vnd\.ms-(excel))/g;
      for (const file of fileList) {
        if (!file.type.match(reg)) {
          this.dialogStatus = true;
          this.res_msg = "File extension not supported!";
          return;
        }
      }

      for (const file of fileList) {
        if (typeof file === "object") {
          this.listSizeFile.push({ size: file.size });
          this.files.push(file);
        }
      }
    },
    removeFile(key) {
      if (this.files.length === 1) {
        this.files = [];
      }
      this.listSizeFile.splice(key, 1);
      this.files.splice(key, 1);
    },
    sumSizeFiles(files) {
      let sum = 0;
      for (let i = 0; i < files.length; i++) {
        sum += files[i].size;
      }
      return sum;
    },
    getColor(data) {
      const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (pattern.test(data)) {
        return "gray";
      } else {
        return "red";
      }
    },
    removeChip(data) {
      this.editedItem.email.splice(this.editedItem.email.indexOf(data), 1);
      this.editedItem.email = [...this.editedItem.email];
    },
    removeSeller(data) {
      this.editedItem.seller_email_address.splice(
        this.editedItem.seller_email_address.indexOf(data),
        1
      );
      this.editedItem.seller_email_address = [
        ...this.editedItem.seller_email_address,
      ];
    },
    changeSort(data) {
      if (typeof data.sortable === "boolean" && !data.sortable) return;
      const column = data.value;
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.pagination.page = 1;
    },
    searchPo: debounce(function searchPo() {
      this.getData();
    }, 800),
    querySearch: debounce(function querySearch(query) {
      this.loadingSelectUser = true;
      this.searchDataUser(query);
    }, 500),
    searchDataUser(query) {
      this.userService
        .getList({
          query,
          limit: 1000,
        })
        .then((res) => {
          if (res && res.docs) {
            this.userList = res.docs.map((e) => {
              return {
                text:
                  [e.first_name, e.last_name].join(" ") + "<" + e.email + ">",
                value: e.id,
              };
            });
          }
          this.loadingSelectUser = false;
        });
    },
    close() {
      this.dialog = false;
      this.dialogConfirm = false;
      this.clickAdd = true;
      this.files = [];
      this.listSizeFile = [];
      this.$nextTick(() => {
        if (this.$refs.files) this.$refs.files.value = "";
      });
    },
    getListModel() {
      this.modelService.getPublicList().then((res) => {
        if (res) {
          this.modelList = res.map((e) => {
            return {
              text: e.name,
              value: e.id,
            };
          });
        }
      });
    },
    getListYear() {
      this.yearList = [];
      for (var i = 2000; i <= 2100; i++) {
        this.yearList.push({
          text: i.toString(),
          value: i.toString(),
        });
      }
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.pagination.page,
        limit: this.pagination.rowsPerPage,
      };
      if (!isEmpty(this.search)) params.search = this.search;
      if (!isEmpty(this.provincesSelected)) {
        params.provinces = this.provincesSelected.join(",");
      }

      if (this.pagination.sortBy) {
        params.sort =
          (this.pagination.descending ? "-" : "") + this.pagination.sortBy;
      }
      this.purchaseOrderService.getList(params).then((res) => {
        this.loading = false;
        if (res && res.docs) {
          this.moduleData = res.docs;
          this.totalItems = res.total;
        }
      });
    },
    editItem(item) {
      this.editedIndex = this.moduleData.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.files = this.editedItem.files ? [...this.editedItem.files] : [];
      this.id = this.moduleData[this.editedIndex].id;
      this.curPOID = this.editedItem.po_number;
      this.editedItem.email = this.editedItem.email.split(",");
      this.editedItem.seller_email_address =
        this.editedItem.seller_email_address.split(",");
      //remove search
      /*this.userList = this.editedItem.assign_users.map(e => {
                return {
                    text:
                        [e.first_name, e.last_name].join(" ") +
                        "<" +
                        e.email +
                        ">",
                    value: e.id
                };
            });*/

      this.editedItem.birthDay = this.editedItem.birthDay
        ? this.$morphDate(
            this.editedItem.birthDay.replace(
              /^(\d{2})\/(\d{2})\/(\d{4})$/,
              "$3-$2-$1"
            ),
            "YYYY-MM-DD"
          )
        : "";
      this.editedItem.assign_users = this.editedItem.assign_users.map(
        (e) => e.id
      );
      this.editedItem.warranty_expired_date = this.editedItem
        .warranty_expired_date
        ? this.$morphDate(this.editedItem.warranty_expired_date, "YYYY-MM-DD")
        : "";
      this.editedItem.maintain_expired_date = this.editedItem
        .maintain_expired_date
        ? this.$morphDate(this.editedItem.maintain_expired_date, "YYYY-MM-DD")
        : "";
      this.editedItem.next_maintain_date = this.editedItem.next_maintain_date
        ? this.$morphDate(this.editedItem.next_maintain_date, "YYYY-MM-DD")
        : "";
      this.editedItem.signing_date = this.editedItem.signing_date
        ? this.$morphDate(this.editedItem.signing_date, "YYYY-MM-DD")
        : "";
      this.editedItem.form_chargeable_maintenance &&
        this.editedItem.form_chargeable_maintenance.form_contact &&
        this.editedItem.form_chargeable_maintenance.form_contact.map((el) => {
          el.contract_signing_date = el.contract_signing_date
            ? this.$morphDate(el.contract_signing_date, "YYYY-MM-DD")
            : "";
          el.effective_time = el.effective_time
            ? this.$morphDate(el.effective_time, "YYYY-MM-DD")
            : "";
        });
        this.editedItem.order_date = this.editedItem.order_date
        ? this.$morphDate(this.editedItem.order_date, "YYYY-MM-DD")
        : "";
      this.dialog = true;
      this.objDate = {
        warranty_expired_date: this.editedItem.warranty_expired_date
          ? this.$morphDate(this.editedItem.warranty_expired_date, "YYYY-MM-DD")
          : format(new Date(), "YYYY-MM-DD"),
        maintain_expired_date: this.editedItem.maintain_expired_date
          ? this.$morphDate(this.editedItem.maintain_expired_date, "YYYY-MM-DD")
          : format(new Date(), "YYYY-MM-DD"),
        next_maintain_date: this.editedItem.next_maintain_date
          ? this.$morphDate(this.editedItem.next_maintain_date, "YYYY-MM-DD")
          : format(new Date(), "YYYY-MM-DD"),
        signing_date: this.editedItem.signing_date
          ? this.$morphDate(this.editedItem.signing_date, "YYYY-MM-DD")
          : format(new Date(), "YYYY-MM-DD"),
      };

      this.listSizeFile = [];
      this.$nextTick(() => {
        if (this.$refs.formPO) this.$refs.formPO.resetValidation();
        this.$validator.reset();
        if (this.$refs.files) this.$refs.files.value = "";
      });

      setTimeout(function () {
        document.getElementsByClassName("dialog-po")[0].scrollTop = 0;
      }, 200);
    },

    editMaintenance(item) {
      this.editedIndex = this.moduleData.indexOf(item);
      this.id = this.moduleData[this.editedIndex].id;
      this.$nextTick(() => {
        this.dialogMaintenance = true;
      });
    },

    editRepair(item) {
      this.editedIndex = this.moduleData.indexOf(item);
      this.id = this.moduleData[this.editedIndex].id;
      this.$nextTick(() => {
        this.dialogRepair = true;
      });
    },

    openDeliveryModal(item) {
      this.editedIndex = this.moduleData.indexOf(item);
      this.id = this.moduleData[this.editedIndex].id;
      this.$nextTick(() => {
        this.dialogDelivery = true;
      });
    },

    /* addContract() {
            this.editedItem.form_chargeable_maintenance && this.editedItem.form_chargeable_maintenance.form_contact && this.editedItem.form_chargeable_maintenance.form_contact.push({
                check_point: false,
                contract_signing_date: null,
                effective_time: null,
                maintenance_contract_number: 0,
                maintenance_package: '',
            });
        }, */

    postPO(data) {
      if (this.editedIndex === -1) {
        this.purchaseOrderService.add(data).then((res) => {
          this.dialogSaving = false;
          this.clickAdd = true;
          if (res.data && res.data.statusCode === 200) {
            this.pagination.sortBy = "createdAt";
            this.pagination.descending = true;
            this.getData();
            this.close();
          } else {
            this.dialogStatus = true;
            this.res_msg = res.data.message;
          }
        });
      } else {
        this.purchaseOrderService.edit(data, this.id).then((res) => {
          this.dialogSaving = false;
          this.clickAdd = true;
          if (res.data && res.data.statusCode === 200) {
            this.getData();
            this.close();
          } else {
            this.dialogStatus = true;
            this.res_msg = res.data.message;
          }
        });
      }
    },
    save() {
      if (!this.clickAdd) return;
      this.clickAdd = false;
      this.$validator.validate("formAddPO.*").then((result) => {
        if (result) {
          if (this.$refs.formPO.validate()) {
            this.dialogSaving = true;
            const { editedItem } = this;
            if (editedItem.periodic_maintenance != null && editedItem.periodic_maintenance !== "") {
              editedItem.periodic_maintenance = +editedItem.periodic_maintenance;
            } else {
              delete editedItem.periodic_maintenance;
            }
            if (editedItem.remaining_periodic_maintenance != null && editedItem.remaining_periodic_maintenance !== "") {
              editedItem.remaining_periodic_maintenance = +editedItem.remaining_periodic_maintenance;
            } else {
              delete editedItem.remaining_periodic_maintenance;
            }
            const emailStr = editedItem.email.join(",");
            const sellerEmailStr = editedItem.seller_email_address.join(",");

            const data = {
              ...editedItem,
              email: emailStr,
              seller_email_address: sellerEmailStr,
              order_date: editedItem.order_date ? this.$morphDate(editedItem.order_date, "YYYY-MM-DD[T00:00:00.000Z]") : null
            };

            if (this.editedIndex === -1) {
              delete data._id;
              delete data.id;
              delete data.createdAt;
              delete data.updatedAt;
              delete data.__v;
            }

            if (typeof data.birthDay === "string" && data.birthDay !== "") {
              data.birthDay = this.$morphDate(data.birthDay, "DD/MM/YYYY");
            } else if (data.hasOwnProperty("birthDay")) {
              data.birthDay = "";
            }

            if (data.hasOwnProperty("province") && !data.province) {
              data.province = "";
            }

            if (typeof this.editedItem.floor !== "number")
              data.floor = Number(data.floor);

            /** @type {import('browser-image-compression').Options */
            const imageCompressionOptions = {
              maxSizeMB: this.LIMIT_SINGLE_IMAGE_SIZE,
              maxWidthOrHeight: this.LIMIT_SINGLE_IMAGE_LONG_EDGE,
              useWebWorker: true,
            };
            if (this.files && this.files.length) {
              Promise.all(
                this.files
                  .filter((file) => !file.url)
                  .map(async (file) => {
                    let fileToUpload = file;
                    if (
                      file.type.match(/image\/*/) &&
                      file.size >
                        this.LIMIT_SINGLE_IMAGE_SIZE * Math.pow(1024, 2)
                    ) {
                      const blob = await imageCompression(
                        file,
                        imageCompressionOptions
                      );
                      fileToUpload = new File([blob], file.name);
                    }
                    const ext = fileToUpload.name.includes(".")
                      ? fileToUpload.name.slice(fileToUpload.name.lastIndexOf("."))
                      : "";
                    const baseName = fileToUpload.name.slice(0, fileToUpload.name.length - ext.length);
                    const renamedFile = new File(
                      [fileToUpload],
                      `${baseName}_${Date.now()}${ext}`,
                      { type: fileToUpload.type }
                    );
                    const formData = new FormData();
                    formData.append("file", renamedFile);
                    return this.purchaseOrderService.uploadFile(formData);
                  })
              ).then((res) => {
                data.files = this.files.filter((file) => file.url).concat(res);
                this.postPO(data);
              });
            } else {
              data.files = [];
              this.postPO(data);
            }
          } else {
            this.clickAdd = true;
          }
        } else {
          this.clickAdd = true;
          this.$refs.formPO.validate();
        }
      });
    },
    eventAddPO() {
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.curPOID = "";
      this.id = "";
      this.files = [];
      this.listSizeFile = [];
      this.dialog = true;
      this.validForm = false;
      this.objDate = {
        warranty_expired_date: format(new Date(), "YYYY-MM-DD"),
        maintain_expired_date: format(new Date(), "YYYY-MM-DD"),
        next_maintain_date: format(new Date(), "YYYY-MM-DD"),
        signing_date: format(new Date(), "YYYY-MM-DD"),
      };
      this.$nextTick(() => {
        if (this.$refs.formPO) this.$refs.formPO.resetValidation();
        this.$validator.reset();
        if (this.$refs.files) this.$refs.files.value = "";
      });
      /* this.editedItem.free_maintenance = true;
            this.editedItem.maintain_num = 0;
            this.editedItem.form_free_maintenance.maintain_num = 0;
            this.editedItem.form_chargeable_maintenance.maintain_num = 0; */
      setTimeout(function () {
        document.getElementsByClassName("dialog-po")[0].scrollTop = 0;
      }, 300);
    },
    byPassOldPO(editedIndex) {
      if (editedIndex === -1) {
        return this.rules.required;
      }
      return;
    },
     allowedPastDates(dateStr) {
      const selectedDate = parse(dateStr, 'yyyy-MM-dd', new Date());
      const todayDate = new Date();
      return isBefore(selectedDate, todayDate) || isEqual(selectedDate, todayDate);
    }
  },
};
</script>

<style>
li {
  text-decoration: none;
  list-style-type: none;
}

.list-poo img {
  max-width: 200px;
}

.dropbox {
  /*outline: 2px dashed grey; !* the dash box *!*/
  outline-offset: -10px;
  /*background: lightcyan;*/
  color: dimgray;
  padding: 10px 10px;
  /*min-height: 200px; !* minimum height *!*/
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  /* invisible but it's there! */
  width: 100%;
  height: 50px;
  position: absolute;
  left: 10px;
  margin-top: 10px;
  top: 0;
  cursor: pointer;
}

.dropbox:hover {
  /*background: lightblue; !* when mouse over to the drop zone, change color *!*/
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.v-toolbar__content {
  /* height: 100% !important; */
}

/* @media screen and (max-width: 600px) {
     .inp-search {
        order: -1;
        flex: 1 0 100%;
    }
} */
table.v-table tbody td a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);
}

.title-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.inp-search {
  max-width: 440px;
  width: 100%;
}

.group-control {
  text-align: center;
}

#pageDashboard .v-datatable__actions {
  position: relative;
}

@media screen and (min-width: 1080px) {
  .actions-list {
    left: calc(50% - 55px);
  }
}

.actions-list {
  position: absolute;
  top: 5px;
}

.v-card__title {
  font-size: 18px;
  font-weight: bold;
  background-color: #f5f5f5;
}

.v-card__actions {
  padding: 15px 10px;
}

.top-content {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.87);
}

table.v-table tbody td {
  word-break: break-word;
}

.list-po tbody tr td:nth-child(1) {
  min-width: 150px;
}

.file-listing {
  display: flex;
}

.name-file {
  max-width: 260px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.accent--text {
  color: #0779ff !important;
}
</style>

<style scoped>
.nowrap {
  white-space: nowrap;
}
</style>
